import { lazy, Suspense } from "react";

const ProjectFiles = lazy(() =>
  import("./ProjectFiles").then((module) => ({ default: module.ProjectFiles }))
);

function LoadingFallback() {
  return (
    <div className="w-full h-full flex items-center justify-center bg-dark-surface-primary">
      <div className="flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-4 border-primary-blue border-t-transparent rounded-full animate-spin" />
        <span className="text-sm text-dark-text-muted">Loading code viewer...</span>
      </div>
    </div>
  );
}

export function ProjectFilesLazy() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <ProjectFiles />
    </Suspense>
  );
}
